import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/registration/welcome-gyre.png'
import _imports_1 from '../assets/registration/user-icon.svg'
import _imports_2 from '../assets/registration/email-icon.svg'
import _imports_3 from '../assets/registration/info-icon.svg'
import _imports_4 from '../assets/registration/lock-icon.svg'
import _imports_5 from '../assets/registration/company-icon.svg'
import _imports_6 from '../assets/registration/Tick-GIF.gif'


const _withScopeId = (n: any) => (_pushScopeId("data-v-78b2e747"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "registration-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "registration-page__welcome" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "welcome-image",
    src: _imports_0,
    alt: "Welcome to Gyre"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "registration-footer" }, [
    /*#__PURE__*/_createElementVNode("ul", { class: "registration-footer-list" }, [
      /*#__PURE__*/_createElementVNode("li", { class: "registration-footer-item" }, [
        /*#__PURE__*/_createElementVNode("a", {
          role: "link",
          href: "https://gyreteams.com"
        }, "About")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "registration-footer-item" }, [
        /*#__PURE__*/_createElementVNode("a", {
          role: "link",
          href: "https://www.gyreteams.com/terms-of-service"
        }, "Terms of Service")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "registration-footer-item" }, [
        /*#__PURE__*/_createElementVNode("a", {
          role: "link",
          href: "https://gyreteams.com/contact"
        }, "Contact")
      ])
    ])
  ])
], -1))
const _hoisted_3 = {
  key: 0,
  class: "registration-page-right"
}
const _hoisted_4 = {
  key: 0,
  class: "viewpoints-invite-box"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://gyreteams.com",
  target: "_blank",
  rel: "noopener noreferrer"
}, "Learn more", -1))
const _hoisted_6 = { class: "registration-form-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Register", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "name-fields" }
const _hoisted_11 = { class: "registration-label-section" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "first-name" }, "First name", -1))
const _hoisted_13 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_14 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_15 = { class: "name-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "User icon"
  })
], -1))
const _hoisted_17 = { class: "registration-label-section" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "last-name" }, "Last name", -1))
const _hoisted_19 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_20 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_21 = { class: "name-field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "User icon"
  })
], -1))
const _hoisted_23 = { class: "registration-label-section" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Work email", -1))
const _hoisted_25 = {
  key: 0,
  style: {"color":"red"},
  "data-test": "invalid-email"
}
const _hoisted_26 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_27 = {
  key: 2,
  style: {"color":"red"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "email icon"
  })
], -1))
const _hoisted_29 = { class: "registration-label-section" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  id: "password-label",
  for: "password"
}, "Password", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "password rules information",
  tabindex: "0",
  id: "password-icon",
  class: "info-icon"
}, null, -1))
const _hoisted_32 = {
  key: 0,
  style: {"color":"red"},
  "data-test": "min-length-password"
}
const _hoisted_33 = {
  key: 1,
  style: {"color":"red"},
  "data-test": "invalid-password"
}
const _hoisted_34 = {
  key: 2,
  style: {"color":"red"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "lock icon"
  })
], -1))
const _hoisted_36 = { class: "registration-label-section" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "confirm" }, "Confirm", -1))
const _hoisted_38 = {
  key: 0,
  style: {"color":"red"},
  "data-test": "mismatched-passwords"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "lock icon"
  })
], -1))
const _hoisted_40 = { class: "registration-label-section" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "company-name" }, "Company name", -1))
const _hoisted_42 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_43 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_44 = {
  key: 2,
  style: {"color":"red"},
  "data-test": "required-company-name"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "company icon"
  })
], -1))
const _hoisted_46 = { class: "checkboxes" }
const _hoisted_47 = { class: "checkbox-default" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "offers-checkbox" }, "(Optional) I'd like to hear about Gyre offers and updates", -1))
const _hoisted_49 = { class: "checkbox-default" }
const _hoisted_50 = {
  key: 0,
  style: {"color":"red","margin-right":"0.5rem"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "terms-checkbox" }, [
  /*#__PURE__*/_createTextVNode("I agree to the "),
  /*#__PURE__*/_createElementVNode("span", { class: "terms-link" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.gyreteams.com/terms-of-service" }, "terms of service")
  ])
], -1))
const _hoisted_52 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_53 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_54 = {
  key: 2,
  style: {"margin-top":"20px"}
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  key: 1,
  class: "registration-page-right success"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "register-success" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "success-gif",
    src: _imports_6,
    alt: "success tick"
  }),
  /*#__PURE__*/_createElementVNode("h2", null, "Success!"),
  /*#__PURE__*/_createElementVNode("p", null, "You have successfully registered. You'll be redirected shortly...")
], -1))
const _hoisted_59 = [
  _hoisted_58
]

import axios, { AxiosResponse, AxiosError } from "axios";
import { debug as d } from "debug";
import { Tooltip } from "uiv";
import useVuelidate from "@vuelidate/core";
import { computed, onMounted, ref } from "vue";
import { email, maxLength, minLength, required, sameAs } from "@vuelidate/validators";
import { useRoute } from "vue-router";
import SubmitButton from "../components/submit-button.vue";
import { InviteCodeSubjectApiModel, RegisterApiModel } from "../api-models";

declare let grecaptcha: any;

const siteKey = "6LfOOSYfAAAAANE6YgdhrYFpz7jtjLdV5wdkYHgi";

export default /*#__PURE__*/_defineComponent({
  __name: 'registration-page',
  props: {
    code: {}
  },
  setup(__props: any) {

const debug = d("cs.RegistrationPage");

const isPasswordValid = (value: string): boolean => {
  const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/;
  const passwordArray = value.match(passwordRegex);
  if (passwordArray) {
    return passwordArray?.length > 0;
  }
  return false;
};

const props = __props;

const isOffersChecked = ref(false);
const isTermsChecked = ref(false);
const emailAlreadyExists = ref(false);
const serverErrorOccurred = ref("");
const firstName = ref("");
const lastName = ref("");
// TODO: rename this so it doesn't clash with vuelidate variable
const userEmail = ref("");
const password = ref("");
const confirmedPassword = ref("");
const companyName = ref("");
const attemptedToSubmit = ref(false);
const registerSuccess = ref(false);
const recaptchaError = ref(false);
const recaptchaToken = ref("");
const submitStatus = ref("");
const viewpointsSubjectName = ref("");
const viewpointsSubjectFirstName = ref("");
const model = ref<RegisterApiModel | null>(null);

const route = useRoute();

const rules = {
  firstName: { required, maxLength: maxLength(50) },
  lastName: { required, maxLength: maxLength(50) },
  userEmail: { required, email, maxLength: maxLength(70) },
  companyName: { required, minLength: minLength(2), maxLength: maxLength(50) },
  password: { required, minLength: minLength(8), isPasswordValid, maxLength: maxLength(40) },
  confirmedPassword: { required, sameAsPassword: sameAs(password) },
  isTermsChecked: { required, sameAs: (value: boolean) => value },
};

const state = {
  firstName,
  lastName,
  userEmail,
  companyName,
  password,
  confirmedPassword,
  isTermsChecked,
};

const v$ = useVuelidate(rules, state, { $autoDirty: true });

const withInvite = computed(() => !!props.code);
const isViewpointsInvite = computed(() => withInvite.value && props.code?.includes("review"));

const googleRecaptchaScript = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;

const canSubmit = computed(() => {
  if (v$.value) {
    return !v$.value.$invalid && !!isTermsChecked.value;
  }

  return false;
});

const isInvitedToTeam = computed(() => withInvite.value && !!model.value?.groupToJoin);
const isInvitedToSubscription = computed(
  () => withInvite.value && !!model.value?.isSubscriptionInvite,
);

function goToSignIn(): void {
  const encodedRedirectUrl = encodeURIComponent(
    isViewpointsInvite.value ? `/invite/accept/${props.code}` : "",
  );

  window.location.href = isViewpointsInvite.value
    ? `/login?ReturnUrl=${encodedRedirectUrl}`
    : "/login";
}

function redirect(location: string): void {
  window.location.href = location;
}

function handleInvalidSource(msg?: string): void {
  if (!msg || !msg.includes("Invalid source")) return;

  serverErrorOccurred.value = "There was an error, please try again.";
  sessionStorage.removeItem("utm_source");
}

function registerFromInvite(data: RegisterApiModel): void {
  axios
    .post(
      `/account/register?id=${props.code}&skipJoined=${route.query.skipJoined ?? "false"}`,
      data,
    )
    .then((res: AxiosResponse) => {
      registerSuccess.value = true;
      redirect(res.headers.location ?? "/home");
    })
    .catch((e: AxiosError) => {
      debug(e);
      const statusCode = e.response?.status;
      submitStatus.value = "";
      if (statusCode === 409) {
        emailAlreadyExists.value = true;
      } else {
        handleInvalidSource(e.response?.statusText);
        serverErrorOccurred.value = "There was a server error. Please try again";
      }
    });
}

function register(data: RegisterApiModel): void {
  axios
    .post("/api/register", data)
    .then((res: AxiosResponse) => {
      if (res.status === 200) {
        registerSuccess.value = true;
        setTimeout(() => {
          window.location.href = res.headers.location ?? "/foundations/default";
        }, 3000);
      }
    })
    .catch((e: AxiosError) => {
      debug(e);
      const statusCode = e.response?.status;
      submitStatus.value = "";
      if (statusCode === 409) {
        emailAlreadyExists.value = true;
      } else if (e.response?.statusText.includes("Recaptcha")) {
        recaptchaError.value = true;
      } else {
        handleInvalidSource(e.response?.statusText);
        serverErrorOccurred.value = String(e);
      }
    });
}

function handleRegistration(): void {
  attemptedToSubmit.value = true;
  if (!canSubmit.value) return;

  const source = sessionStorage.getItem("utm_source");

  const newUserData = {
    firstName: firstName.value.trim(),
    lastName: lastName.value.trim(),
    email: userEmail.value.trim(),
    companyName: companyName.value.trim(),
    password: confirmedPassword.value,
    optInForMarketing: isOffersChecked.value,
    recaptchaToken: recaptchaToken.value,
    source: source ?? "",
  } as RegisterApiModel;

  if (withInvite.value) {
    registerFromInvite(newUserData);
  } else {
    register(newUserData);
  }
}

function submitForm(): void {
  attemptedToSubmit.value = true;
  debug(v$.value.$invalid);
  if (v$.value.$invalid) {
    submitStatus.value = "Error";
  } else {
    submitStatus.value = "OK";
    handleRegistration();
  }
}

async function setRecaptcha(): Promise<void> {
  await grecaptcha.execute(siteKey, { action: "Register" }).then((token: string) => {
    recaptchaToken.value = token;
  });
}

function checkReCaptcha(): void {
  grecaptcha.ready(async () => {
    await setRecaptcha();
    submitForm();
  });
}

function setRegistrationModel(): void {
  axios
    .get(`/api/register/${route.params.code}?skipJoined=${route.query.skipJoined ?? "false"}`)
    .then((res: AxiosResponse) => {
      if (res.headers.location) {
        redirect(res.headers.location);
      } else {
        model.value = res.data;
      }
    })
    .catch((reason: AxiosError) => {
      serverErrorOccurred.value = String(reason);
    });
}

onMounted(() => {
  if (!withInvite.value) {
    const script = document.createElement("script");
    script.type = "application/javascript";
    script.src = googleRecaptchaScript;
    document.head.appendChild(script);
  }

  if (isViewpointsInvite.value) {
    axios
      .get<InviteCodeSubjectApiModel>(`/api/invitecode/subject/${props.code}`)
      .then((response) => {
        viewpointsSubjectName.value = response.data.name;
        viewpointsSubjectFirstName.value = response.data.firstName;
      });
  }

  const source = route.query?.utm_source as string;
  if (source && typeof source === "string" && source.trim() !== "") {
    sessionStorage.setItem("utm_source", source);
  }

  if (v$.value) {
    v$.value.$reset();
  }

  if (withInvite.value) {
    setRegistrationModel();
  }
});

const isSubmitted = computed(() => submitStatus.value === "OK");

// this is so the name fields don't look wonky when only one has a validation error message appearing
function otherNameFieldHasValidationError(nameField: "firstName" | "lastName"): boolean {
  if (submitStatus.value === "Error") {
    return nameField === "firstName"
      ? !v$.value.lastName.required && v$.value.firstName.required
      : !v$.value.firstName.required && v$.value.lastName.required;
  }
  return false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (!registerSuccess.value)
      ? (_openBlock(), _createElementBlock("article", _hoisted_3, [
          (isViewpointsInvite.value && viewpointsSubjectName.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, _toDisplayString(viewpointsSubjectName.value), 1),
                  _createTextVNode(" has invited you to complete a review of " + _toDisplayString(viewpointsSubjectFirstName.value) + "'s character strengths. This will help " + _toDisplayString(viewpointsSubjectFirstName.value) + " build an accurate self-view. ", 1),
                  _hoisted_5
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("span", null, [
                _createTextVNode("Already have an account? "),
                _createElementVNode("a", {
                  onClick: goToSignIn,
                  href: "javascript:void(0)",
                  "data-test": "rwi-sign-in"
                }, "Sign in")
              ]),
              (isInvitedToTeam.value)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_8, " Register your account to join " + _toDisplayString(model.value?.groupToJoin.name) + ". ", 1))
                : _createCommentVNode("", true),
              (isInvitedToSubscription.value)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_9, " Register your account to join your organisation on Gyre "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("form", {
              method: "post",
              onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (withInvite.value ? submitForm() : checkReCaptcha()), ["prevent"])),
              class: _normalizeClass(["registration-form", { 'registration-form--with-invite': withInvite.value }])
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  (_unref(v$).firstName?.required.$invalid && submitStatus.value === 'Error')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Required field "))
                    : _createCommentVNode("", true),
                  (_unref(v$).firstName?.maxLength.$invalid && submitStatus.value === 'Error')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Maximum of 50 characters allowed "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      id: "first-name",
                      class: "registration-text-input",
                      type: "text",
                      placeholder: "First name",
                      name: "first-name",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((firstName).value = $event)),
                      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_unref(v$).firstName?.$touch())),
                      "data-test": "rwi-first-name"
                    }, null, 544), [
                      [
                        _vModelText,
                        firstName.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _hoisted_16
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  (_unref(v$).lastName?.required.$invalid && submitStatus.value === 'Error')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Required field "))
                    : _createCommentVNode("", true),
                  (_unref(v$).lastName?.maxLength.$invalid && submitStatus.value === 'Error')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Maximum of 50 characters allowed "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      id: "last-name",
                      class: "registration-text-input",
                      type: "text",
                      placeholder: "Last name",
                      name: "last-name",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((lastName).value = $event)),
                      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_unref(v$).lastName?.$touch())),
                      "data-test": "rwi-last-name"
                    }, null, 544), [
                      [
                        _vModelText,
                        lastName.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _hoisted_22
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                (_unref(v$).userEmail?.email.$invalid && submitStatus.value === 'Error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Invalid email address "))
                  : _createCommentVNode("", true),
                (_unref(v$).userEmail?.required.$invalid && submitStatus.value === 'Error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Required field "))
                  : _createCommentVNode("", true),
                (_unref(v$).userEmail?.maxLength.$invalid && submitStatus.value === 'Error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, " Maximum of 70 characters allowed "))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  class: "registration-text-input",
                  placeholder: "Enter work email",
                  name: "email",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userEmail).value = $event)),
                  onBlur: _cache[5] || (_cache[5] = ($event: any) => (_unref(v$).userEmail?.$touch())),
                  "data-test": "rwi-email"
                }, null, 544), [
                  [
                    _vModelText,
                    userEmail.value,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _hoisted_28
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("span", null, [
                  _hoisted_30,
                  _hoisted_31,
                  _createVNode(_unref(Tooltip), {
                    text: "Must be a minimum of 8 characters in length. Must include at least one number, one uppercase and one lowercase letter. No spaces at the beginning or end.",
                    "data-html": "true",
                    target: "#password-icon",
                    "custom-class": "password-tooltip"
                  })
                ]),
                (
                (_unref(v$).password?.minLength.$invalid || _unref(v$).password?.required.$invalid) &&
                submitStatus.value === 'Error'
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, " Minimum 8 characters long. "))
                  : _createCommentVNode("", true),
                (_unref(v$).password?.isPasswordValid.$invalid && submitStatus.value === 'Error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, " Must include a number, an upper and a lower case letter. "))
                  : _createCommentVNode("", true),
                (_unref(v$).password?.maxLength.$invalid && submitStatus.value === 'Error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Maximum of 40 characters allowed "))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  "aria-labelledby": "password-label",
                  class: "registration-text-input",
                  type: "password",
                  placeholder: "Password",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((password).value = $event)),
                  id: "password",
                  onBlur: _cache[7] || (_cache[7] = ($event: any) => (_unref(v$).password?.$touch())),
                  "data-test": "rwi-password"
                }, null, 544), [
                  [
                    _vModelText,
                    password.value,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _hoisted_35
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                (_unref(v$).confirmedPassword?.sameAsPassword.$invalid && submitStatus.value === 'Error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Those passwords didn't match. Try again. "))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  id: "confirm",
                  class: "registration-text-input",
                  type: "password",
                  placeholder: "Confirm password",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((confirmedPassword).value = $event)),
                  onBlur: _cache[9] || (_cache[9] = ($event: any) => (_unref(v$).confirmedPassword?.$touch())),
                  "data-test": "rwi-password-confirm"
                }, null, 544), [
                  [
                    _vModelText,
                    confirmedPassword.value,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _hoisted_39
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                (_unref(v$).companyName?.minLength.$invalid && submitStatus.value === 'Error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, " Company name should be at least 2 characters long "))
                  : _createCommentVNode("", true),
                (_unref(v$).companyName?.maxLength.$invalid && submitStatus.value === 'Error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, " Maximum of 40 characters allowed "))
                  : _createCommentVNode("", true),
                (_unref(v$).companyName?.required.$invalid && submitStatus.value === 'Error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, " Required field "))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  id: "company-name",
                  class: "registration-text-input",
                  type: "text",
                  placeholder: "Company name",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((companyName).value = $event)),
                  onBlur: _cache[11] || (_cache[11] = ($event: any) => (_unref(v$).companyName?.$touch())),
                  "data-test": "rwi-company-name"
                }, null, 544), [
                  [
                    _vModelText,
                    companyName.value,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _hoisted_45
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    name: "offers-checkbox",
                    id: "offers-checkbox",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((isOffersChecked).value = $event))
                  }, null, 512), [
                    [_vModelCheckbox, isOffersChecked.value]
                  ]),
                  _hoisted_48
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    name: "terms-checkbox",
                    id: "terms-checkbox",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((isTermsChecked).value = $event)),
                    onChange: _cache[14] || (_cache[14] = ($event: any) => (_unref(v$).isTermsChecked?.$touch())),
                    class: _normalizeClass({ required: !_unref(v$).isTermsChecked?.$invalid && attemptedToSubmit.value }),
                    "data-test": "rwi-terms"
                  }, null, 34), [
                    [_vModelCheckbox, isTermsChecked.value]
                  ]),
                  (_unref(v$).isTermsChecked?.$invalid && attemptedToSubmit.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, " Required. "))
                    : _createCommentVNode("", true),
                  _hoisted_51
                ])
              ]),
              (!!serverErrorOccurred.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Something went wrong, please try again later."))
                : _createCommentVNode("", true),
              (recaptchaError.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_53, "Recaptcha failed to verify your identity. Please refresh the page and try again."))
                : (emailAlreadyExists.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                      _createTextVNode("This email already exists in Gyre. "),
                      _hoisted_55,
                      _createElementVNode("a", {
                        onClick: goToSignIn,
                        href: "javascript:void(0)"
                      }, "Sign in"),
                      (withInvite.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_56, " before accepting this invite."))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
              _createVNode(SubmitButton, {
                class: "registration-submit-button",
                buttonClass: "btn-primary",
                "is-submitted": isSubmitted.value,
                "data-form-type": "action,register",
                "use-recaptcha": true,
                "data-test": "rwi-submit",
                disabled: false
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isViewpointsInvite.value ? "Register & Accept Invite" : "Register"), 1)
                ]),
                _: 1
              }, 8, ["is-submitted"])
            ], 34)
          ])
        ]))
      : _createCommentVNode("", true),
    (registerSuccess.value)
      ? (_openBlock(), _createElementBlock("article", _hoisted_57, _hoisted_59))
      : _createCommentVNode("", true)
  ]))
}
}

})